export default {
  'site-name': 'Gifta Blog',
  'site-title': 'Gifta Blog',
  'gifta-site-title': 'Gifta Website',
  'gifta-site-link': 'https://www.gifta.it/',
  'pixa-site-title': 'Pixartprinting Website',
  'pixa-site-link': 'https://www.pixartprinting.it/',
  'load-more-article': 'Leggi altri articoli',
  'next-slide': 'Successivo',
  'prev-slide': 'Precedente',
  'next-pagination': 'Successivi',
  'prev-pagination': 'Precedenti',
  'next-article': 'Articolo successivo',
  'related-articles': 'Articoli correlati',
  'back-to-top': 'Torna su',
  search: 'Cerca',
  'erase-research': 'Cancella ricerca',
  close: 'Chiudi',
  'newsletter-title': 'Newsletter',
  'newsletter-text':
    'Sii tra i primi ad essere aggiornato <br> sulle novità di Gifta blog.',
  'newsletter-cta': 'Iscriviti',
}
